import Validator from '../../validator';

const ChangeDesignatedPersonValidator = new Validator([
  {
    field: 'effDate',
    method: 'isEmpty',
    validWhen: false,
    message: 'Effective Date is required.',
  },
  {
    field: 'current',
    method: 'isEmpty',
    validWhen: false,
    message: 'Current Designated Officer/Contact Person is required.',
  },
  {
    field: 'new',
    method: 'isEmpty',
    validWhen: false,
    message: 'New Designated Officer/Contact Person is required.',
  },
  {
    field: 'reason',
    method: 'isEmpty',
    validWhen: false,
    message: 'Reason for Change is required.',
  },
  {
    field: 'file',
    method: 'isEmpty',
    validWhen: false,
    message: 'Request signed by the Insured is required.',
  },
]);

export default ChangeDesignatedPersonValidator;
